
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/split",
      function () {
        return require("private-next-pages/destinations/split.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/split"])
      });
    }
  